export function equals<T>(obj1: T, obj2: T, getProperty?: ((obj: T) => any)): boolean {
    if (obj1 == null && obj2 == null) {
        return true;
    }

    if (obj1 == null || obj2 == null) {
        return false;
    }

    const p1 = getProperty == null ? obj1 : getProperty(obj1);
    const p2 = getProperty == null ? obj2 : getProperty(obj2);

    const isNullish = (p: any) => p == null || (typeof p === 'number' && isNaN(p));
    const isP1Nullish = isNullish(p1);
    const isP2Nullish = isNullish(p2);

    if (isP1Nullish && isP2Nullish) {
        return true;
    }

    if (isP1Nullish || isP2Nullish) {
        return false;
    }

    if (typeof p1 === 'object' && typeof p1['equals'] === 'function') {
        return p1['equals'](p2);
    }

    return p1 === p2;
}
